import script from "./LeftColumnLV.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftColumnLV.vue?vue&type=script&setup=true&lang=js"

import "./LeftColumnLV.vue?vue&type=style&index=0&id=1c732360&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c732360"]])

export default __exports__